import { Stack, Typography, Box } from "@mui/material";
import { PropsWithChildren } from "react";

const FormSectionHeader = ({ children }: PropsWithChildren) => (
  <Stack
    component={Box}
    mt={7}
    alignItems="center"
    direction="row"
    position="relative"
  >
    <Box
      sx={{
        position: "absolute",
        border: "1px solid #c8c8c8",
        right: "0",
        left: "0",
      }}
    />
    <Typography
      color="secondary.main"
      fontWeight="700"
      pr={2}
      sx={{ backgroundColor: "common.white", position: "relative" }}
    >
      {children}
    </Typography>
  </Stack>
);

export default FormSectionHeader;
